import { render } from "./AIFunctionPropsCmp.vue?vue&type=template&id=4363215c"
import script from "./AIFunctionPropsCmp.vue?vue&type=script&lang=js"
export * from "./AIFunctionPropsCmp.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__